import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ContentLoader from "react-content-loader";
import { useNavigate } from "react-router-dom";
import {
  updateListingLastPage,
  updateListingLoading,
  updateListingPage,
  updateListings,
} from "../../../store/slicers/listingSlice";
import { convertToKebabCase } from "../../../utils/common";

export const List = ({
  service_img,
  service_name,
  service_type_code,
  image,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  const handleClick = () => {
    dispatch(updateListingLoading(false));
    dispatch(updateListingLastPage(false));
    dispatch(updateListingPage(1));
    dispatch(updateListings([]));
    navigate(
      `/category/${service_type_code}/${convertToKebabCase(service_name)}`
    );
  };

  const contentLoad = () => {
    return (
      <ContentLoader
        speed={1}
        width="10rem"
        height="10rem"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect rx="10" ry="10" width="10rem" height="10rem" />
      </ContentLoader>
    );
  };

  return (
    <div className="h-full w-full border rounded-2xl px-4 py-2 hover:opacity-70">
      <div
        key={service_type_code}
        className="cursor-pointer flex justify-center items-center"
        onClick={handleClick}
        style={{
          height: "10rem",
          width: "10rem",
          overflow: "hidden", 
          position: "relative",
        }}
      >
        {contentLoad()}

        <img
          draggable="false"
          onLoad={() => setIsLoading(false)}
          alt={service_name}
          src={image}
          className="absolute top-0 left-0 w-full h-full object-contain bg-white"
          style={{
            display: isLoading ? "none" : "block",
          }}
        />
      </div>

      <h2 className="px-2 pt-3 text-sm text-primary-600 text-center">
        {service_name}
      </h2>
    </div>
  );
};
